import { env } from '@fiverr-private/futile';

export const isBrowser = () => env.browser && typeof window !== 'undefined';

// README: https://docs.fiverr-gw.com/platform/perseus/migration/migrating_from_v2#no-more-window-over-node
/** @type {() => (typeof window) | undefined } */
export const getWindow = () => isBrowser() ? window : undefined;

/** @type {() => Document | undefined } */
export const getDocument = () => getWindow()?.document;
